import React from 'react';
import classNames from 'classnames';
import { safeHTML } from '../../../../utils/safeHTML';
import Reward from '../../../baseComponents/gui/reward/Reward';
import { stores, useTranslation } from '../../../../translations';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';
import useGetIsTruthTime from '../../../../hooks/shared/time/useGetIsTruthTime';

export default function ShelfInfo({ reward, title, text, type, dates }) {
  const { t } = useTranslation();
  const { getLocalizedText } = useLanguageControls();
  const getIsTruthTime = useGetIsTruthTime();

  return (
    (!dates || getIsTruthTime(dates)) && (
      <div
        className={classNames(`shelf__info`, {
          [`shelf__info_${type}`]: type,
        })}
      >
        <div className={`shelf__info-reward`}>
          <Reward
            {...reward}
            mod={classNames('shelf', {
              [`reward_${reward.mod}`]: reward.mod,
            })}
          />
        </div>
        <div className={`shelf__info-block`}>
          {title && (
            <div className={'shelf__info-title'}>{safeHTML(getLocalizedText(t(title, { returnObjects: true })))}</div>
          )}
          <p className={'shelf__info-text'}>{safeHTML(getLocalizedText(t(text, { returnObjects: true })))}</p>
        </div>
      </div>
    )
  );
}
